import styled from "styled-components"
import { ContentWrapper as GlobalContentWrapper } from "../../ui/content-wrapper/content-wrapper-elements"
import {
  ButtonWrapperStyles,
  ContentStyles,
  ContentWrapperStyles,
  DescriptionStyles,
  HeaderWrapperStyles,
  VideoBackgroundStyles,
} from "./header-styles"
import { BreakPoints, media } from "../../helpers/rwd"

interface IHeaderWrapper {
  bgImg: string
}

export const HeaderWrapper = styled.header<IHeaderWrapper>`
  padding: 50px 0;
  background-image: url(${props => props.bgImg});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  overflow: hidden;
  ${media.max(BreakPoints.tablet)} {
    padding-top: 0;
    padding-bottom: 25px;
  }
  ${HeaderWrapperStyles}
`

export const VideoBackground = styled.video`
  position: absolute;
  top: -60px;
  width: 100%;
  ${VideoBackgroundStyles}
`

export const ContentWrapper = styled(GlobalContentWrapper)`
  ${ContentWrapperStyles}
`

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 50px 0 20px;
  ${media.max(BreakPoints.tablet)} {
    align-items: center;
  }
  ${ContentStyles}
`

export const Description = styled.p`
  ${media.max(BreakPoints.tablet)} {
    text-align: center;
  }
  ${DescriptionStyles}
`

export const ButtonWrapper = styled.div`
  display: flex;
  & > a {
    margin-right: 30px;
  }
  ${media.max(BreakPoints.tablet)} {
    & > a {
      margin-left: 15px;
      margin-right: 15px;
    }
  }
  ${ButtonWrapperStyles}
`
